// extracted by mini-css-extract-plugin
module.exports = {"form_arrow_down_icon_frame":"selectVehicles_form_arrow_down_icon_frame__drGrK","save_form_btn":"selectVehicles_save_form_btn__1WSXL"};